import { render, staticRenderFns } from "./FormBadges.vue?vue&type=template&id=01a2f944&scoped=true&"
import script from "./FormBadges.vue?vue&type=script&lang=js&"
export * from "./FormBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2f944",
  null
  
)

export default component.exports